<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      center
      title="导入 商品基本信息"
      :save-func="() => {}"
      :confirm-on-close-change="false"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <div style="text-align: center; margin-bottom: 30px">
          <div style="margin-top: 15px">
            <import-file
              :upload-url="api.import"
              :text="text"
              w="150px"
              @on-uploaded="uploaded"
            />
          </div>
          <div style="margin-top: 30px">
            <el-button size="mini" style="width: 150px" plain @click="download"
              >下载导入模板</el-button
            >
          </div>
          <div style="margin-top: 30px" v-if="detailUrl">
            <el-button
              size="mini"
              style="width: 150px"
              type="danger"
              plain
              @click="detail"
              >下载错误明细</el-button
            >
          </div>
        </div>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import importFile from "@/components/common/files/importFile";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    importFile,
  },
  data() {
    return {
      api: require("@/api/goods/info").default,
      attach: require("@/api/common/attach").default,
      detailUrl: "",
      TermId: null,
      TermName: "",
      text: "导入商品基本信息",
    };
  },
  computed: {},
  methods: {
    download() {
      var name = "商品信息导入模板.xlsx";
      this.attach.downloadByUrl("/Template/" + name, name);
    },
    detail() {
      this.attach.downloadByUrl(this.detailUrl, "错误明细.xlsx");
    },
    uploaded(res) {
      if (res.Code != 0) {
        if (res.Code == 2) {
          this.detailUrl = res.Data;
        } else {
          this.$message.error(res.Msg);
        }
      } else {
        this.$emit("upload-success");
        this.detailUrl = "";
      }
    },
  },
};
</script>
  <style lang="scss">
</style>